import * as React from 'react';

import ErrorCatch from '../../containers/ErrorBoundary/ErrorCatch';
import { alphacolors } from '../../shared/data';
import { addModifiers } from '../../shared/helpers';

import './ColorProperties.scss';

interface ColorPropertiesProps {
  color: string;
  handleColorChange: (color: string) => void;
  disabled?: boolean;
}

export const ColorProperties = ({ color, handleColorChange, disabled }: ColorPropertiesProps) => {
  try {
    return (
      <div className={addModifiers('color-properties', disabled ? ['disabled'] : [])}>
        {alphacolors.map((elem: string, index: number) => {
          const setChildTabAsActive = () => handleColorChange(elem);
          const newColor = color === '' ? 'NONE' : color;

          return (
            <div
              key={index}
              className={`${newColor === elem ? 'color-properties__item--active' : ''}
                            color-properties__item color-properties__item--${elem}`}
              onClick={setChildTabAsActive}
            >
              {elem === 'NONE' && 'None'}
            </div>
          );
        })}
      </div>
    );
  } catch (error) {
    return <ErrorCatch error={error} />;
  }
};

export default ColorProperties;
